import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";

export const FooterWrapper = styled.div`
    padding: 4rem ${globalStyles.desktop.pageMargin};
    margin-top: 5rem;
    text-align: center;
    background-color: #e5e7eb;

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        padding-left: ${globalStyles.mobile.pageMargin};
        padding-right: ${globalStyles.mobile.pageMargin};
    }
`
    
export const FooterData = styled.div`
    display: flex;

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        flex-direction: column;
    }
`

export const FooterContent = styled.div`
    width: 40%;
    margin: auto;
    
    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        width: 100%;
    }
`

export const FooterLogo = styled.img`
    height: 4rem;
`

export const SocialMediaIcons = styled.ul`
    list-style-type: none;
    padding-inline-start: 0;
`

export const SocialMediaIcon = styled.li`
    display: inline-block;
    padding: 0 0.5rem;
    margin: 0 1rem;
    cursor: pointer;
`

export const FooterLinks = styled.div`
    margin: auto;
`

export const LinksColumn = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0;
    
    a {
        text-decoration: none;
    }
`

export const Copyright = styled.p`
    font-size: 0.75rem;
    margin-top: 2rem;
`